export const formatTryTimeRemaining = (time: number) => {
  if (time < 0) {
    return '0:00';
  }

  const remainingMinutes = Math.floor(time / 60);
  const remainingSeconds = time % 60;

  return `${remainingMinutes}:${
    remainingSeconds < 10 ? '0' : ''
  }${remainingSeconds}`;
};
